export default __webpack_public_path__ + "static/media/brochure devpack.2419f624.pdf";